import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquareIcon, MessageSquareIcon, UsersIcon } from 'lucide-react';
const solutions = [{
  icon: <CheckSquareIcon className="h-10 w-10 text-brand-teal" data-id="element-248" />,
  title: 'Workflows',
  features: ['Task lists and boards', 'Due dates and reminders', 'Progress tracking', 'Custom workflows']
}, {
  icon: <MessageSquareIcon className="h-10 w-10 text-brand-teal" data-id="element-249" />,
  title: 'Client communication',
  features: ['Shared timelines', 'Client notes', 'Message threads', 'File sharing']
}, {
  icon: <UsersIcon className="h-10 w-10 text-brand-teal" data-id="element-250" />,
  title: 'Team collaboration',
  features: ['Comments and mentions', 'File sharing', 'Activity feeds', 'Team dashboards']
}];
export const SolutionOverview = () => {
  return <section className="py-16 bg-gradient-to-b from-brand-light to-white" data-id="element-251">
      <div className="container-custom" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-253">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-254">
            Everything your team needs in one place
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-255">
            Daily Serve combines the essential tools your team uses every day
            into one seamless platform.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-256">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-257">
              <div className="mb-6 flex justify-center" data-id="element-258">{solution.icon}</div>
              <h3 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-259">
                {solution.title}
              </h3>
              <ul className="space-y-3" data-id="element-260">
                {solution.features.map((feature, i) => <li key={i} className="flex items-center justify-center" data-id="element-261">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-teal mr-2" data-id="element-262"></span>
                    <span className="text-gray-700" data-id="element-263">{feature}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
};